import React from 'react';

const LogIcon = ({ fill }) => {
  return (
    <svg t="1605561064232" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2985" width="15" height="15" xlink="http://www.w3.org/1999/xlink">
      <defs>
        <style type="text/css" />
      </defs>
      <path d="M733.129568 1.700997H1.700997v1020.598006h1020.598006v-765.448505z m204.119601 935.548172h-850.498338v-850.498338h614.910299l235.588039 206.671096z" p-id="2986" fill={fill} />
      <path
        d="M170.099668 171.800664h279.813953v85.049834H170.099668zM170.099668 372.518272h683.800664v85.049834H170.099668zM170.099668 567.282392h683.800664v85.049834H170.099668zM170.099668 762.046512h683.800664v85.049834H170.099668z"
        p-id="2987"
        fill={fill}
       />
    </svg>
  );
};

export default LogIcon;
